import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

import { createTableData } from './BaseTable.blockgroup.utils';

const BaseTable = ({ rawData = [], columnConfigs = [], loading = false, onRowClick, sortModel, onSortModelChange }) => {

    // Use the column configurations and the raw data to create columns and rows for the table
    const tableData = {...createTableData(columnConfigs, rawData)}

    return (<DataGrid 
        sortModel={sortModel} 
        onSortModelChange={onSortModelChange} 
        sx={{ backgroundColor: "white"}} 
        disableSelectionOnClick 
        rows={tableData.rows} 
        columns={tableData.columns} 
        onRowClick={onRowClick ? (params) => onRowClick(params) : null}  
        loading={loading} 
    />)
}

export default BaseTable;